// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `pnpm build-icons` instead of editing. */ import { ReactComponent as CheckCircleBrokenDefault } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/default/general/check-circle-broken.svg?react';
import { ReactComponent as CheckCircleBrokenSolid } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/solid/general/check-circle-broken.svg?react';
import { createIcons } from '../../Icon';
export const CheckCircleBrokenIcon = /* @__PURE__ */ createIcons('CheckCircleBroken', {
    default: CheckCircleBrokenDefault,
    solid: CheckCircleBrokenSolid
});
CheckCircleBrokenIcon.supportedTypes = [
    'default',
    'solid'
];
